import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBucket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconBucket"><Path d="M3.58503 9L5.00582 20.3432C5.05282 20.7185 5.37183 21 5.75 21H18.25C18.6282 21 18.9472 20.7185 18.9942 20.3432L20.415 9H3.58503Z" fill="currentColor"/><Path d="M2.75 3C2.33579 3 2 3.25184 2 3.5625V6.9375C2 7.24816 2.33579 7.5 2.75 7.5H21.25C21.6642 7.5 22 7.24816 22 6.9375V3.5625C22 3.25184 21.6642 3 21.25 3H2.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBucket;
